function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "background-layer_bottom");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Screen",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop-HD-Copy-6",
  transform: "translate(0.000000, -907.000000)",
  fill: "#DED0CC"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,929.853932 C37.5,929.853932 80.6067035,917.400473 178,917.344419 C275.393297,917.288365 300.5,940.920039 419,940.920039 C462.666136,940.920039 502.808372,917.987412 580,917.344419 C615.424863,917.049336 649.725101,940.834412 701.5,940.920039 C753.274899,941.005666 815.234776,920.608512 846.5,920.608527 C938,920.608527 973.5,936.830391 1073,936.830391 C1172.5,936.830391 1256.49144,907.009784 1336.5,907 C1416.50856,906.990244 1395.5,917.344419 1440,917.344419 C1440,933.061499 1440,968.613353 1440,1023.99998 L0,1023.99998 C0,983.688919 0,952.306904 0,929.853932 Z",
  id: "background-layer_bottom"
})));

var SvgBackgroundLayerBottom = function SvgBackgroundLayerBottom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1440px",
    height: "117px",
    viewBox: "0 0 1440 117",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBackgroundLayerBottom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/background-layer_bottom.568a417b.svg";
export { ForwardRef as ReactComponent };